/**
 * Lifts the loading screen (#loader in index.html) once the yard is worth
 * showing. Until its painting, water, nest and egg have loaded, the yard can
 * only draw a stand-in (flat sky, an oval for the nest, flat water), which on
 * a slow connection sat there for seconds (docs/mockups/loading-screen.html).
 *
 * index.html lifts it by itself after ten seconds, so neither an image that
 * never arrives nor a game that fails to start can keep the page hidden.
 */

/** Matches the fade in index.html's .loader transition. */
const FADE_MS = 300;

/** Fades the loading screen out now; a no-op once it is gone. */
export function liftLoader(): void {
  const loader = document.getElementById('loader');
  if (!loader || loader.classList.contains('loader--gone')) return;
  loader.classList.add('loader--gone');
  window.setTimeout(() => loader.remove(), FADE_MS);
}

/** Lifts the loading screen on the first frame that `ready` holds. */
export function liftLoaderWhen(ready: () => boolean): void {
  const check = (): void => {
    if (!document.getElementById('loader')) return;
    if (ready()) liftLoader();
    else requestAnimationFrame(check);
  };
  requestAnimationFrame(check);
}
